import { DraftOrder } from '../../types/orders';
import fulfill from '../../fulfill';
import { SideEffectFunction } from '../../sideEffects';
import { ActionTypes, GetDraftOrder, DraftOrderResponse, DraftOrderNotFoundResponse } from './actions';
import { CORE_API_HOSTNAME } from '../../env';

type FetchDraftOrderResult = DraftOrderResponse | DraftOrderNotFoundResponse;

const fetchDraftOrder: SideEffectFunction<GetDraftOrder, FetchDraftOrderResult> = async (action) => {
    const result: FetchDraftOrderResult = await fulfill.get({
        accountId: action.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.payload.accountId}/shopping/draft_orders/${action.payload.id}`,
        handlers: {
            200: (draft: DraftOrder) => ({
                type: ActionTypes.DraftOrderResponse,
                payload: {
                    draft,
                },
                meta: {
                    cause: action,
                },
            }),
            404: () => ({
                type: ActionTypes.DraftOrderNotFoundResponse,
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

const effects = {
    [ActionTypes.GetDraftOrder]: fetchDraftOrder,
};

export default effects;
